import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import React, { useEffect } from 'react';
import { Level } from '../../enums/Level';

const Relogin = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const paremLevel = params.get('level');
  useEffect(() => {
    if (
      paremLevel &&
      (paremLevel === Level.staff || paremLevel === Level.teamLead)
    ) {
      window.location.href = '/myactions';
    } else {
      window.location.href = '/dashboard';
    }
  }, []);

  return (
    <>
      <LoadingContent />
    </>
  );
};

export default Relogin;
